/**
 * Generates a random position for a window within a square around the center point
 * Ensures the window stays fully visible within the viewport
 */

export const getRandomWindowPosition = (windowWidth = 700, windowHeight = 500) => {
  // Get viewport dimensions
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  
  // Calculate center point
  const centerX = viewportWidth / 2;
  const centerY = viewportHeight / 2;
  
  // Define the square bounds around the center (small-ish square)
  const squareSize = 200; // pixels from center in each direction
  const halfSquare = squareSize / 2;
  
  // Calculate the bounds for the square
  const minX = centerX - halfSquare;
  const maxX = centerX + halfSquare;
  const minY = centerY - halfSquare;
  const maxY = centerY + halfSquare;
  
  // Generate random position within the square
  const randomX = Math.random() * squareSize + minX;
  const randomY = Math.random() * squareSize + minY;
  
  // Calculate the final position (accounting for window dimensions)
  // We need to ensure the window doesn't go off-screen
  const finalX = Math.max(0, Math.min(randomX - windowWidth / 2, viewportWidth - windowWidth));
  const finalY = Math.max(0, Math.min(randomY - windowHeight / 2, viewportHeight - windowHeight - 30)); // 30px for taskbar
  
  // Convert to CSS translate values (relative to center)
  const tx = finalX - centerX + windowWidth / 2;
  const ty = finalY - centerY + windowHeight / 2;
  
  return {
    tx: Math.round(tx),
    ty: Math.round(ty)
  };
};

/**
 * Gets a random position for a window with default dimensions
 */
export const getDefaultRandomPosition = () => {
  return getRandomWindowPosition();
};
